import { useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { useIsOfferCardPage } from './useIsOfferCardPage';
import { selectPageType } from '../selectors/page';
import { TPageType } from '../types/page';

const INCLUDED_PAGES: TPageType[] = [
  'main',
  'mainCountryside',
  'mainSale',
  'mainRent',
  'mainRentDaily',
  'favorites',
  'chats',
  'lk',
];

export const useMobileBottomNavigation = () => {
  const pageType = useSelector(selectPageType);

  const isOfferCardPage = useIsOfferCardPage();

  const deviceType = useDeviceType();

  return (
    deviceType !== 'desktop' &&
    (INCLUDED_PAGES.includes(pageType) || ((pageType === 'search' || pageType === 'offerCard') && !isOfferCardPage))
  );
};
